import { hooks } from '@wove/react';
import { CSSProperties, useState } from 'react';
import { FlexLayout } from '../flex-layout';
import { useEffectCustom } from '../hooks';
import { Picker, PickerColumnItem, PickerColumnValue } from '../picker';
import { CommonProps } from '../utils/native-props';
import './style.less';

export type PickerCascadeDataSourceItem = PickerColumnItem & { children?: PickerColumnItem[] };

export type PickerCascadeProps = {
  dataSource: PickerCascadeDataSourceItem[];
  value?: PickerColumnValue[];
  onChange?: (pickerColumnItem: PickerColumnItem[]) => void;
} & CommonProps<{ '--height': CSSProperties['height'] }>;

export const PickerCascade = (props: PickerCascadeProps) => {
  const dataSource = props.dataSource || [];
  const [picker1ActiveIndex, setPicker1ActiveIndex] = useState<number>(0);
  const [picker2ActiveItem, setPicker2ActiveItem] = useState<PickerColumnItem>();

  useEffectCustom(() => {
    const value = props.value;
    if (!value) return;
    if (value.length > 0) {
      const target1Index = dataSource.findIndex((temp) => temp.value === value[0]);
      const children = dataSource[target1Index].children;
      const target2Item = children?.find((temp) => temp.value === value[1]);
      if (target2Item) {
        setPicker1ActiveIndex(target1Index);
        setPicker2ActiveItem(target2Item);
        return;
      }
      setPicker1ActiveIndex(0);
      setPicker2ActiveItem(dataSource[0].children?.[0]);
    }
  }, [props.value]);

  const onChangePicker1 = hooks.useCallbackRef((item: PickerColumnItem) => {
    if (item.value === dataSource[picker1ActiveIndex].value) return;
    const targetIndex = dataSource.findIndex((temp) => temp.value === item.value);
    const children = dataSource[targetIndex].children || [];
    setPicker1ActiveIndex(targetIndex);
    setPicker2ActiveItem(children?.[0]);
    props.onChange?.([{ label: item.label, value: item.value }, children?.[0]]);
  });

  const onChangePicker2 = hooks.useCallbackRef((item: PickerColumnItem) => {
    if (item.value === picker2ActiveItem?.value) return;
    setPicker2ActiveItem(item);
    props.onChange?.([
      {
        label: dataSource[picker1ActiveIndex].label,
        value: dataSource[picker1ActiveIndex].value,
      },
      item,
    ]);
  });

  return (
    <FlexLayout fullIndex={[0, 1]} direction="horizontal" className="v-picker-cascade">
      <Picker
        pickerDataList={dataSource}
        onChange={onChangePicker1}
        value={dataSource[picker1ActiveIndex].value}
      />
      <Picker
        pickerDataList={dataSource[picker1ActiveIndex].children || []}
        value={picker2ActiveItem?.value}
        onChange={onChangePicker2}
      />
    </FlexLayout>
  );
};
